import { getSDKConfig } from './getSDKConfig';

const isDesktopAllowedByDomain = (): boolean => {
  const allowedDomains = (process.env.NX_ALLOWED_DESKTOP || '')
    .split(',')
    .map((d) => d.trim());
  const currentDomain = window.location.hostname;

  if (allowedDomains.includes(currentDomain)) {
    return true;
  }

  for (const allowed of allowedDomains) {
    if (allowed === '*') {
      return true;
    }

    if (allowed.startsWith('*.')) {
      const baseDomain = allowed.substring(2);
      if (
        currentDomain.endsWith(`.${baseDomain}`) ||
        currentDomain === baseDomain
      ) {
        return true;
      }
    }
  }

  return false;
};

export const isDesktopEnabled = (): boolean => {
  const enableDesktop = getSDKConfig()?.swipeGames?.enableDesktop ?? false;

  return enableDesktop || isDesktopAllowedByDomain();
};
